import React from 'react';
export var DataContext = /*#__PURE__*/React.createContext({
  data: []
});